import * as React from 'react'
import GoogleMapReact from 'google-map-react'
import { MapProvider, MapContext } from 'components/map/MapContext'
import { GlobalContext } from 'components/Store'

const App = ({ className, ...props }) => {
	const {
		defaults,
		set$geocoder,
		$center,
		set$center,
		$zoom,
		set$zoom,
		set$bounds,
		resetMap,
	} = React.useContext(MapContext)

	const { featuredLocations } = React.useContext(GlobalContext)

	function onChange({ center, zoom, bounds }) {
		set$center(center)
		set$zoom(zoom)
		set$bounds(bounds)

		if (typeof document === 'undefined') return
		document.querySelector('.projects-list')?.scrollTo(0, 0)
	}

	React.useEffect(() => {
		if (typeof window === 'undefined') return

		const params = new URLSearchParams(window.location.search)
		const location = featuredLocations?.find(
			({ name }) => name === params.get('location'),
		)?.location

		!!location && set$center(location)
	}, [featuredLocations, set$center])

	function onSelection({ target }) {
		if (!target?.value) return

		if (target.value === 'reset') {
			resetMap()
		} else {
			if (!target.value) return
			set$center(JSON.parse(target.value))
		}
	}

	return (
		<>
			<label className="space-y-2">
				<div className="technical-lg text-xs">Locations:</div>
				<select
					className="w-full cursor-pointer rounded-full border border-current bg-transparent px-4 py-2 text-white/60 *:text-ink"
					onChange={onSelection}
				>
					<option default disabled>
						Select one
					</option>

					<option value="reset">California</option>

					{featuredLocations?.map(({ name, location }, key) => (
						<option value={JSON.stringify(location)} key={key}>
							{name}
						</option>
					))}
				</select>
			</label>

			<div className={className}>
				<GoogleMapReact
					bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_API_KEY }}
					{...defaults}
					center={$center}
					zoom={$zoom}
					yesIWantToUseGoogleMapApiInternals
					onChange={onChange}
					onGoogleApiLoaded={({ map, maps }) =>
						set$geocoder(new maps.Geocoder())
					}
					{...props}
				/>
			</div>
		</>
	)
}

const Map = (props) => (
	<MapProvider>
		<App {...props} />
	</MapProvider>
)

export default Map
